<template>
  <teleport to="body">
    <jet-dialog-modal
      id="userCartViewerModal"
      maxWidth="lg"
      icon="fas fa-shopping-cart"
    >
      <template #title>User Cart</template>
      <template #content>
        <div class="embed-responsive embed-responsive-4by3">
          <iframe
            v-show="url"
            :src="url"
            class="print-frame embed-responsive-item"
            title="Cart"
          ></iframe>
          <jet-button class="px-5" btnStyle="success" icon="fas fa-shopping-cart" @click="goToCheckout()">Checkout for MTD</jet-button><br/>
          <small>Click on checkout for MTD will clear all items in the current admin MTD cart and put these items to the cart</small>
        </div>
      </template>
      <template #footer> </template>
    </jet-dialog-modal>
  </teleport>
</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal'

export default {
  props: {
    url: String,
    mtdId: Number,
  },
  components: {
    JetDialogModal
  },
  methods: {
    goToCheckout() {
      $('#userCartViewerModal').modal('hide');
      this.$inertia.visit(route('admin.mtd.transfer_cart', this.mtdId), {
      });  
    },
  }
}
</script>

<style>
.modal-tall {
  height: 90%;
}

.modal-tall div.modal-content {
  height: 100%;
}

iframe.print-frame {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
